<template>
    <div class="attachments-wrapper">
        <div class="attachments-header">
            <div class="attachment-count">
                <i class="material-icons">attachment</i>
                <span>{{ $t("mail.emailAttachments", { count: attachments.length }) }}</span>
            </div>
        </div>
        <div class="attachments-list">
            <attachment-item 
                v-for="attachment in attachments" 
                :key="attachment.name || attachment.id" 
                :attachment="attachment" 
            />
        </div>
    </div>
</template>

<script>
import AttachmentItem from './AttachmentItem.vue';

export default {
    name: "AttachmentList",
    components: {
        AttachmentItem
    },
    props: {
        attachments: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.attachments-wrapper {
    padding: 16px 24px;
    background-color: #f5f5f5;
    border-top: 1px solid #eaeaea;

    .attachments-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .attachment-count {
            display: flex;
            align-items: center;

            i {
                font-size: 18px;
                color: #666;
                margin-right: 8px;
            }

            span {
                font-size: 14px;
                font-weight: 500;
                color: #444;
            }
        }
    }

    .attachments-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
}
</style> 